import React, { Component } from 'react'
import styles from "./DownloadComp.module.css"

import { jsPDF } from "jspdf";
import domtoimage from 'dom-to-image';
import { v4 as uuidv4 } from 'uuid';

const DEFAULT_DOM_DOWNLOAD_ID = "design-map-0"
export default class DownloadComp extends Component {
    constructor(props) {
        super(props)
    }

    // Handler
    downloadAsPdf = (img) => {
        var imgInst = new Image()
        //onload listener
        imgInst.onload = () => {
            const pdfType = (imgInst.width > imgInst.height) ? "landscape" : "portrait"
            const pdf = new jsPDF(pdfType, 'px', [imgInst.width, imgInst.height]);
            console.log(imgInst.width, imgInst.height, pdf.internal.pageSize.getWidth())
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = (imgInst.height * pdfWidth) / imgInst.width;
            pdf.addImage(img, 'PNG', 0, 0, pdfWidth, pdfHeight);
            pdf.save("My-Layout.pdf");
        }
        //load img src
        imgInst.src = img
    }
    downloadAsPng = (img) => {
        var link = document.createElement('a');
        link.download = 'My-Layout.png';
        link.href = img;
        link.click();
    }

    downloadHandler = (e, type = "PNG") => {
        var rootHtml = document.getElementById(DEFAULT_DOM_DOWNLOAD_ID)
        domtoimage.toPng(rootHtml).then(img => {
            if (type == "PNG") {
                this.downloadAsPng(img)
            }
            if (type == "PDF") {
                this.downloadAsPdf(img)
            }
        });
    }
    render() {
        const id = uuidv4()
        const downloadType = (this.props.type) ? this.props.type : "PNG"
        return (
            <div className={styles.highlightClass}
                onClick={(e) => this.downloadHandler(e, downloadType)}>
                {downloadType}
                <img className={styles.imgIconStyle} src="https://img.icons8.com/color/48/000000/download--v1.png" />
            </div>
        )
    }
}
